// 2023区域统计
<template>
  <div class='reportDetails' style='background-color:#fff;' >
    <!-- <div class="update-box" v-if="!isShowEmpty&&!isLoading">
      <div class="update df-between" :style="{'top':topHeight}">
        <div class='left'>每日凌晨2:00更新报告数据</div>
      </div>
    </div> -->
    <div class="container" v-if="!isShowEmpty&&!isLoading" style='background-color:#eee;'>
      <webHeader v-if='reportData.isWeb==1' :isWeb='reportData.isWeb' v-on:handleCatelogue='handleCatelogue' v-on:setWord='setWord'></webHeader>
      <areaStatistics class='areaStatistics' v-on:sendEchartsImg="sendEchartsImg" :reportData='reportData' ></areaStatistics>
      <dragIndex :source='$route.query.source' v-if='reportData.isWeb!=1' :isWeb='reportData.isWeb' v-on:handleShare='handleShare' v-on:handleCatelogue='handleCatelogue' v-on:handleDownLoad='handleDownLoad'></dragIndex>
      <v-catalogue ref="catalogue" :catalogueData="catalogueData" :isWeb='reportData.isWeb' safeContainerDomId="hps-scroll"></v-catalogue>
    </div>
    <div class="empty " v-if='isShowEmpty&&!isLoading' style='background-color:#fff;'>
      <img src="../../assets/images/notAuditRecord.png" alt="" >
      <div class='empty-text' style='font-size:18px;color:#333;'>{{this.delText}}</div>
    </div>
    <van-action-sheet v-model="actionSheetLeft" :actions="actions1" cancel-text="取消" close-on-click-action @select="selectActionSheetLeft" />
    <div class="actionSheetRIght-box">
      <van-action-sheet v-model="actionSheetRIght" :actions="actions2" cancel-text="取消" close-on-click-action @select="selectActionSheetRight" />
    </div>
    <!-- <div class="footer df-center" >
      <button class="online-save" @click="onlineSave" >在线发送</button>
      <button class="download-save" @click="setWord" >下载后发送</button>
    </div> -->
  </div>
</template>
<script>
  import Vue from 'vue'
  import areaStatistics from './areaStatisticsChild2023'
  import dragIndex from './dragIndex.vue'
  import webHeader from './webHeader'
  import store from '@/store/index'
  import vCatalogue from '../../components/catelogue/catalogue.vue'
  import {mapState, mapGetters } from 'vuex'
  import axios from 'axios'
  import { Toast } from 'vant'

  Vue.use(Toast)
  export default {
    props:['containerHeight','topHeight'],
    data() {
      return {
        taskId:'',
        provinceCode:'',
        cityCode:'',
        districtCode:'',
        districtType:'',
        level:'',
        comCategory:'',
        catalogueData:[
          {
            title: '1. 区域手卫生知识知晓率情况',
            domId: 'hps-1',
            children: [
              {
                title: '1.1 区域手卫生学习任务完成情况',
                domId: 'hps-1.1'
              },
              {
                title: '1.2 区域手卫生考试情况',
                domId: 'hps-1.2'
              },
              {
                title: '1.3 区域手卫生证书获得情况',
                domId: 'hps-1.3'
              },
            ]
          },
          {
            title: '2. 区域调查科室手卫生依从及正确执行情况',
            domId: 'hps-2',
            children: [
              {
                title: '2.1 区域调查科室洗手/卫生手消毒依从及正确执行情况',
                domId: 'hps-2.1',
                children: [
                  {
                    title: '2.1.1 不同规模医院洗手/卫生手消毒时机依从率/正确率',
                    domId: 'hps-2.1.1'
                  },
                  {
                    title: '2.1.2 不同指征洗手/卫生手消毒时机依从率/正确率',
                    domId: 'hps-2.1.2'
                  },
                  {
                    title: '2.1.3 不同岗位人员洗手/卫生手消毒时机依从率/正确率',
                    domId: 'hps-2.1.3'
                  },
                  {
                    title: '2.1.4 不同岗位人员洗手/卫生手消毒指征依从率/正确率',
                    domId: 'hps-2.1.4'
                  },
                  {
                    title: '2.1.5 各科室洗手/卫生手消毒平均依从率/正确率情况',
                    domId: 'hps-2.1.5'
                  },
                  {
                    title: '2.1.6 各医疗机构洗手/卫生手消毒平均依从率/正确率情况',
                    domId: 'hps-2.1.6'
                  },
                ]
              },
              {
                title: '2.2 区域调查科室外科手消毒依从及正确执行情况',
                domId: 'hps-2.2',
                children: [
                  {
                    title: '2.2.1 不同规模医院外科手消毒时机依从率/正确率',
                    domId: 'hps-2.2.1'
                  },
                  {
                    title: '2.2.2 不同指征外科手消毒时机依从率/正确率',
                    domId: 'hps-2.2.2'
                  },
                  {
                    title: '2.2.3 各医疗机构外科手消毒平均依从率/正确率情况',
                    domId: 'hps-2.2.3'
                  },
                ]
              }
            ]
          },
          {
            title: '3. 区域调查科室手卫生用品消耗情况',
            domId: 'hps-3',
            children: [
              {
                title: '3.1 各科室手卫生用品消耗调查概况',
                domId: 'hps-3.1'
              },
              {
                title: '3.2 不同规模医疗机构各科室手卫生用品消耗情况',
                domId: 'hps-3.2',
                children: [
                  {
                    title: '3.2.1 【骨科】手卫生用品消耗情况',
                    domId: 'hps-3.2.1'
                  },
                  {
                    title: '3.2.2 【呼吸科(组)】手卫生用品消耗情况',
                    domId: 'hps-3.2.2'
                  },
                  {
                    title: '3.2.3 【感染病科(组)】手卫生用品消耗情况',
                    domId: 'hps-3.2.3'
                  },
                  {
                    title: '3.2.4 【综合ICU】手卫生用品消耗情况',
                    domId: 'hps-3.2.4'
                  },
                  {
                    title: '3.2.5 【儿科门急诊】手卫生用品消耗情况',
                    domId: 'hps-3.2.5'
                  },
                  {
                    title: '3.2.6 【血液透析室】手卫生用品/手套消耗情况',
                    domId: 'hps-3.2.6'
                  },
                  {
                    title: '3.2.7 【手术部（室）】手卫生用品消耗情况',
                    domId: 'hps-3.2.7'
                  },
                ]
              },
              {
                title: '3.3 各医院手卫生用品消耗抽检概况',
                domId: 'hps-3.3',
                children: [
                  {
                    title: '3.3.1 不同规模医疗机构手卫生用品合格率情况',
                    domId: 'hps-3.3.1'
                  },
                  {
                    title: '3.3.2 不同规模医疗机构抽检微生物含量超标后处置及可能超标原因',
                    domId: 'hps-3.3.2'
                  },
                ]
              },
            ]
          },
          {
            title: '4. 区域重点质控指标情况',
            domId: 'hps-4',
            children: [
              {
                title: '4.1 2022年重点质控指标概况',
                domId: 'hps-4.1'
              },
              {
                title: '4.2 不同规模医疗机构2022年重点质控指标情况',
                domId: 'hps-4.2'
              }
            ]
          },
          {
            title: '5. 管理提示',
            domId: 'hps-5',
            children: [
              {
                title: '5.1 手卫生依从率与手卫生用品消耗量相关性分析',
                domId: 'hps-5.1'
              },
              {
                title: '5.2 手卫生依从率与重点质控指标相关性分析',
                domId: 'hps-5.2'
              }
            ]
          },
          {
            title: '附1 手卫生知识学习任务清单',
            domId: 'hps-fu1'
          },
          {
            title: '附2 手卫生考试题目',
            domId: 'hps-fu2'
          },
        ],
        actions1: [
          { name: '通过微信/QQ发送' }
        ],
        actions2: [
          {
            name: '脱敏下载分享',
            subname: '(为保障数据隐私安全，建议您脱敏分享)',
          },
          { name: '下载分享' },
        ],
        actionSheetLeft: false,
        actionSheetRIght: false,
        isShowEmpty: true, // 所有数据为空
        isLoading:true, //加载中
        delText: '无数据',
        formData: {},
        echartsChildData: {}, // 所有子组件获取的echarts图存在这里
        reportData: {
          batch:'',
          isWeb:0,
          isDesensitization: '',
          fileId: '',
          baseUrl: '',
        }
      }
    },
    computed: {
      ...mapGetters([
      ]),
      ...mapState({
        _userInfo: (state) => state.InvestorInfo,
        baseUrl: (state) => state._base
      })
    },
    created() {
      this.taskId = this.$route.query.taskId ? this.$route.query.taskId : localStorage.getItem('taskId')
      this.reportData.batch = this.$route.query.batch ? this.$route.query.batch : localStorage.getItem('batch')
      this.catalogueData = this.getProcessedCatalogueData(parseInt(this.reportData.batch - 1))
      this.reportData.baseUrl = this.baseUrl
      this.reportData.isWeb = this.$route.query.isWeb
      if(this.reportData.isWeb == 1){
        this.actions2[0].name = '脱敏下载'
        this.actions2[0].subname = '(为保障数据隐私安全，建议您脱敏下载)'
        this.actions2[1].name = '下载'
      }
      this.formData = new FormData()
      this.initData()
      console.log(window.location.href,'当前url地址');
    },
    mounted() {
      document.title = '报告详情'
    },
    components: {
      areaStatistics: areaStatistics,
      dragIndex:dragIndex,
      vCatalogue,
      webHeader
    },
    methods: {
      getProcessedCatalogueData(year) {
        const processData = (data) => {
          return data.map(item => {
            const newItem = { ...item };
            
            // 替换标题中的年份
            if (newItem.title && typeof newItem.title === 'string') {
              newItem.title = newItem.title.replace(/2022/g, year.toString());
            }
            
            // 递归处理子节点
            if (newItem.children && newItem.children.length > 0) {
              newItem.children = processData(newItem.children);
            }
            
            return newItem;
          });
        };

        const clonedData = this.catalogueData;
        return processData(clonedData);
      },
      // 分享
      handleShare(){
        this.onlineSave()
      },
      // 下载
      handleDownLoad(){
        this.setWord()
      },
      // 目录
      handleCatelogue(){
        this.$refs['catalogue'].openCatalogue()
      },
      initData(){
        store.commit('showLoading')
        this.$http.getUserHandActivityInfo({
          userId: this.$route.query.userId?this.$route.query.userId:this._userInfo.data.userId,
          sub_id: "",
          comId: this.$route.query.comId?this.$route.query.comId:this._userInfo.data.comId,
          data: {
            comId: this.$route.query.comId?this.$route.query.comId:this._userInfo.data.comId,
            userId: this.$route.query.userId?this.$route.query.userId:this._userInfo.data.userId,
            handTaskId: this.taskId?this.taskId:this.$route.query.taskId
          },
          malVersion: "A0"
        }).then((res) => {
            if (res.code === 0) {
              this.reportData.handComplianceTarget = res.data.reportTarget.handComplianceTarget
              this.reportData.handCorrectionTarget = res.data.reportTarget.handCorrectionTarget
              this.provinceCode = res.data.provinceCode || '' // 省
              this.cityCode = res.data.cityCode || '' // 市
              this.districtCode = res.data.districtCode || '' //区县
              this.districtType = res.data.districtType || '' // 是否新疆兵团
              this.level = res.data.level || '' // 医院等级
              this.comCategory = res.data.comCategory || '' // 医院类型
              this.initAreaStatisticsBody()
            } else {
              this.$toast(res.msg)
            }
        })
      },
      initAreaStatisticsBody() {
        Promise.all([
          this.$http
            .queryHandAreaStatisticsReport001_2023({
              P_PROVINCE_CODE:`'${this.provinceCode}'`,
              P_CITY_CODE:`'${this.cityCode}'`,
              P_DISTRICT_CODE:`'${this.districtCode}'`,
              P_USER_LEVEL:this.level,
              P_COM_CATEGORY:`'${this.comCategory}'`,
              P_DISTRICT_TYPE:this.districtType,
              P_TASK_ID: this.taskId
            })
            .then((res) => {
              this.reportData.contentObj = res.data[0][0] || []
              this.reportData.contentObj.reportTitle = this.reportData.contentObj.CONTENT2.substring(0,4) + '年'+ this.reportData.contentObj.CONTENT0 + (this.comCategory==2?'新疆兵团医院':this.reportData.contentObj.CONTENT1)+'医务人员诊疗过程手卫生监测专项报告'
              this.reportData.tableOneData = res.data[1] || []
              this.reportData.tableTwoData = this.handleMergeRow(res.data[2] || [])
              this.reportData.tableThreeData = res.data[3] || []
              this.reportData.echartsOneData =  res.data[3] || []
              this.reportData.tableFourData = res.data[4] || []
              this.reportData.tableFiveData = res.data[5] || []
              this.reportData.tableSixData = res.data[6] || []
            }).catch((err) => {
              this.isShowEmpty = true
            }),
          this.$http
            .queryHandAreaStatisticsReport002_2023({
              P_PROVINCE_CODE:`'${this.provinceCode}'`,
              P_CITY_CODE:`'${this.cityCode}'`,
              P_DISTRICT_CODE:`'${this.districtCode}'`,
              P_USER_LEVEL:this.level,
              P_COM_CATEGORY:`'${this.comCategory}'`,
              P_DISTRICT_TYPE:this.districtType,
              P_TASK_ID: this.taskId
            })
            .then((res) => {
              if (res.code == 0) {
                this.reportData.contentObj1 = res.data[0][0] || []
                this.reportData.tableSevenData = res.data[1] || []
                this.reportData.tableEightData = res.data[2] || []
                this.reportData.tableNineData = res.data[3] || []
                this.reportData.tableTenData = this.handleMergeRow1(res.data[4] || [])
                this.reportData.tableElevenData = res.data[5] || []
                this.reportData.tableTwelveData = res.data[6] || []
              }
            }).catch((err) => {
              this.isShowEmpty = true
            }),
          this.$http
          .queryHandAreaStatisticsReport003_2023({
            P_PROVINCE_CODE:`'${this.provinceCode}'`,
            P_CITY_CODE:`'${this.cityCode}'`,
            P_DISTRICT_CODE:`'${this.districtCode}'`,
            P_USER_LEVEL:this.level,
            P_COM_CATEGORY:`'${this.comCategory}'`,
            P_DISTRICT_TYPE:this.districtType,
            P_TASK_ID: this.taskId
          })
          .then((res) => {
            this.reportData.contentObj2 = res.data[0][0] || []
            this.reportData.tableThirteenData = res.data[1] || []
            this.reportData.tableFourteenData = res.data[2] || []
            this.reportData.tableFifteenData = res.data[3] || []
            this.reportData.tableFifteen_4Data = res.data[8] || []
            this.reportData.tableSixteenData = this.handleMergeRow2(res.data[4] || [])
            this.reportData.tableSeventeenData = res.data[5] || []
            this.reportData.tableEighteenData = res.data[6] || []
            this.reportData.tableNineteenData = res.data[7] || []
            this.reportData.tableNineteen_12Data = res.data[9] || []
          }).catch((err) => {
              this.isShowEmpty = true
            }),
          this.$http
          .queryHandAreaStatisticsReport004_2023({
            P_PROVINCE_CODE:`'${this.provinceCode}'`,
            P_CITY_CODE:`'${this.cityCode}'`,
            P_DISTRICT_CODE:`'${this.districtCode}'`,
            P_USER_LEVEL:this.level,
            P_COM_CATEGORY:`'${this.comCategory}'`,
            P_DISTRICT_TYPE:this.districtType,
            P_TASK_ID: this.taskId
          })
          .then((res) => {
            this.reportData.contentObj3 = res.data[0][0] || []
            this.reportData.tableTwentyData = this.handleMergeRow3(res.data[1] || [])
            this.reportData.tableTwentyOneData = res.data[2] || []
            this.reportData.tableTwentyTwoData = res.data[3] || []
            this.reportData.tableTwentyThreeData = res.data[4] || []
            this.reportData.tableTwentyFourData = res.data[5] || []
            this.reportData.tableTwentyFiveData = res.data[6] || []
            this.reportData.tableTwentySixData = res.data[7] || []
          }).catch((err) => {
              this.isShowEmpty = true
            }),
          this.$http
          .queryHandAreaStatisticsReport005_2023({
            P_PROVINCE_CODE:`'${this.provinceCode}'`,
            P_CITY_CODE:`'${this.cityCode}'`,
            P_DISTRICT_CODE:`'${this.districtCode}'`,
            P_USER_LEVEL:this.level,
            P_COM_CATEGORY:`'${this.comCategory}'`,
            P_DISTRICT_TYPE:this.districtType,
            P_TASK_ID: this.taskId
          })
          .then((res) => {
            this.reportData.echartsTwoData = []
            this.reportData.echartsThreeData = []
            this.reportData.echartsFourData = []
            this.reportData.echartsFiveData = []
            this.reportData.echartsSixData = []
            this.reportData.echartsSevenData = []

            this.reportData.echartsEightData = []
            this.reportData.echartsNineData = []
            this.reportData.echartsTenData = []
            this.reportData.echartsElevenData = []
            this.reportData.echartsTwelveData = []
            this.reportData.echartsThirteenData = []
            let scatterData1 = res.data[0] || []
            let scatterData2 = res.data[1] || []
            if(scatterData1.length>0){
              scatterData1.forEach((v,i)=>{
                if(v.COL1!=null&&v.COL2!=null){
                  this.reportData.echartsTwoData.push([parseFloat(v.COL2),parseFloat(v.COL1)])
                }
                if(v.COL3!=null&&v.COL4!=null){
                  this.reportData.echartsThreeData.push([parseFloat(v.COL4),parseFloat(v.COL3)])
                }
                if(v.COL5!=null&&v.COL6!=null){
                  this.reportData.echartsFourData.push([parseFloat(v.COL6),parseFloat(v.COL5)])
                }
                if(v.COL7!=null&&v.COL8!=null){
                  this.reportData.echartsFiveData.push([parseFloat(v.COL8),parseFloat(v.COL7)])
                }
                if(v.COL9!=null&&v.COL10!=null){
                  this.reportData.echartsSixData.push([parseFloat(v.COL10),parseFloat(v.COL9)])
                }
                if(v.COL11!=null&&v.COL12!=null){
                  this.reportData.echartsSevenData.push([parseFloat(v.COL12),parseFloat(v.COL11)])
                }
              })
            }
            console.log(this.reportData.echartsTwoData,'echartsTwoData');

            if(scatterData2.length>0){
              scatterData2.forEach((v,i)=>{
                if(v.COL1!=null&&v.COL2!=null){
                  this.reportData.echartsEightData.push([parseFloat(v.COL1),parseFloat(v.COL2)])
                }
                if(v.COL1!=null&&v.COL3!=null){
                  this.reportData.echartsNineData.push([parseFloat(v.COL1),parseFloat(v.COL3)])
                }
                if(v.COL1!=null&&v.COL4!=null){
                  this.reportData.echartsTenData.push([parseFloat(v.COL1),parseFloat(v.COL4)])
                }
                if(v.COL1!=null&&v.COL5!=null){
                  this.reportData.echartsElevenData.push([parseFloat(v.COL1),parseFloat(v.COL5)])
                }
                if(v.COL1!=null&&v.COL6!=null){
                  this.reportData.echartsTwelveData.push([parseFloat(v.COL1),parseFloat(v.COL6)])
                }
                if(v.COL1!=null&&v.COL7!=null){
                  this.reportData.echartsThirteenData.push([parseFloat(v.COL1),parseFloat(v.COL7)])
                }
              })
            }
          }).catch((err) => {
              this.isShowEmpty = true
            }),
          this.$http
            .queryHandAreaStatisticsReport006_2023({
              P_TASK_ID: this.taskId
            })
            .then((res) => {
              if (res.code == 0) {
                this.reportData.tableTwentySevenData = this.handleMergeRowTwo(res.data[0] || [])
                this.reportData.tableTwentyEightData = res.data[1] || []
              }
            }).catch((err) => {
              this.isShowEmpty = true
            }),
          this.$http
            .queryHandAreaStatisticsReport007_2023({
              P_PROVINCE_CODE:`'${this.provinceCode}'`,
              P_CITY_CODE:`'${this.cityCode}'`,
              P_DISTRICT_CODE:`'${this.districtCode}'`,
              P_USER_LEVEL:this.level,
              P_COM_CATEGORY:`'${this.comCategory}'`,
              P_DISTRICT_TYPE:this.districtType,
              P_TASK_ID: this.taskId
            })
            .then((res) => {
              if (res.code == 0) {
                console.log('区域新增');
                this.reportData.contentObj4= res.data[0][0]
                this.reportData.tableSeven_7Data = res.data[1] || []
                this.reportData.tableEight_8Data = res.data[2] || []
                this.reportData.tableEleven_9Data = res.data[3] || []
                if(!this.reportData.contentObj4.CONTENT2){
                  this.catalogueData[1].children.splice(1,1) // 去掉外科手消毒目录
                }
              }
            }).catch((err) => {
              this.isShowEmpty = true
            }),
          this.$http
            .queryHandAreaStatisticsReport008_2023({
              P_PROVINCE_CODE:`'${this.provinceCode}'`,
              P_CITY_CODE:`'${this.cityCode}'`,
              P_DISTRICT_CODE:`'${this.districtCode}'`,
              P_USER_LEVEL:this.level,
              P_COM_CATEGORY:`'${this.comCategory}'`,
              P_DISTRICT_TYPE:this.districtType,
              P_TASK_ID: this.taskId
            })
            .then((res) => {
              if (res.code == 0) {
               if(parseInt(this.reportData.batch) < 2025){
                 this.catalogueData[2].children.splice(2,1) // 去掉手卫生用品抽检情况
               }
               this.reportData.contentObj008 = res.data[0][0] || {}
                this.reportData.tableNineteen_13Data = res.data[1] || []
                this.reportData.tableNineteen_14Data = res.data[2] || []
                this.reportData.tableNineteen_15Data = res.data[3] || []
                this.reportData.tableNineteen_16Data = res.data[4] || []
                this.reportData.tableNineteen_17Data = res.data[5] || []
                this.reportData.tableNineteen_18Data = res.data[6] || []
                this.reportData.tableNineteen_19Data = res.data[7] || []
                this.reportData.tableNineteen_20Data = res.data[8] || []
              }
            }).catch((err) => {
              this.isShowEmpty = true
            }),
        ])
          .then((res) => {
            this.isLoading = false
            this.isShowEmpty = false
            store.commit('hideLoading')
          })
          .catch((err) => {
            this.isShowEmpty = true
            console.log(err)
          })
      },
      selectActionSheetLeft(name, index) {
        if (index == 1) {
          // 在app内发送到单元
          this.isShowRole = true
        } else {
          // 通过微信发送
          let url = `${this.baseUrl}/handMonitorReported/#/areaStatistics2023?source=1&comId=${this._userInfo.data.comId}&userId=${this._userInfo.data.userId}&taskId=${this.taskId}&handComplianceTarget=${this.reportData.handComplianceTarget}&handCorrectionTarget=${this.reportData.handCorrectionTarget}&batch=${this.reportData.batch}`
          // let url = `${this.baseUrl}/#/areaStatistics?source=1&comId=${this._userInfo.data.comId}&userId=${this._userInfo.data.userId}&taskId=${this.taskId}`
          let title = this.reportData.contentObj.reportTitle
          let content = '仅限院内分享，请注意数据安全'
          try {
            uni.postMessage({
              data: {
                action: 'showShareView',
                data: {
                  shareUrl: url,
                  shareTitle: title,
                  shareContent: content,
                }
              }
            });
            window.webkit.messageHandlers.showShareView.postMessage({
              shareUrl: url,
              shareTitle: title,
              shareContent: content,
            })
          } catch (err) {
            window.gk.showShareView(url, title, content)
          }
        }
      },
      handleWindowGk(fileName) {
        try {
          uni.postMessage({
            data: {
              action: 'downLoad',
              data: {
                url:
                  this.reportData.baseUrl +
                  '/incontrol-fileserver/file/download/' +
                  this.reportData.fileId +
                  '.docx',
                reportId: -1,
                rptTitleAlias: fileName,
                isDesensitization: this.reportData.isDesensitization,
              }
            }
          });
          window.webkit.messageHandlers.downLoad.postMessage({
            url:
              this.reportData.baseUrl +
              '/incontrol-fileserver/file/download/' +
              this.reportData.fileId +
              '.docx',
            reportId: -1,
            rptTitleAlias: fileName,
            isDesensitization: this.reportData.isDesensitization,
          })
        } catch (err) {
          window.gk.downLoad(
            this.reportData.baseUrl +
              '/incontrol-fileserver/file/download/' +
              this.reportData.fileId,
            -1,
            this.reportData.isDesensitization == 0
              ? fileName + '(脱敏)'
              : fileName
          )
        }
      },
      selectActionSheetRight(name, index) {
        if(this.reportData.isWeb !=1){
          let userData = this._userInfo.data
          this.utils.cnzzStat('H5-全国手卫生监测专项报告-医疗机构','下载报告(Um_Event_DownloadReport)',`${userData.userId}-${userData.postName}-${userData.comName}-${userData.isSign == '1' ? '已签约': '未签约'}-${userData.comProvinceName}`)
        }
        if (index == 0) {
          // 脱敏处理
          this.reportData.isDesensitization = '0'
        } else {
          this.reportData.isDesensitization = '1'
        }
        this.$nextTick(() => {
          this.formData.append('reportData', JSON.stringify(this.reportData))
          this.formData.append('files1', this.echartsChildData.echartsUrl1)
          this.formData.append('files2', this.echartsChildData.echartsUrl2)
          this.formData.append('files3', this.echartsChildData.echartsUrl3)
          this.formData.append('files4', this.echartsChildData.echartsUrl4)
          this.formData.append('files5', this.echartsChildData.echartsUrl5)
          this.formData.append('files2_7', this.echartsChildData.echartsUrl2_7)
          this.formData.append('files3_7', this.echartsChildData.echartsUrl3_7)
          this.formData.append('files4_7', this.echartsChildData.echartsUrl4_7)
          this.formData.append('files5_7', this.echartsChildData.echartsUrl5_7)
          this.formData.append('files6', this.echartsChildData.echartsUrl6)
          this.formData.append('files7', this.echartsChildData.echartsUrl7)
          this.formData.append('files8', this.echartsChildData.echartsUrl8)
          this.formData.append('files9', this.echartsChildData.echartsUrl9)
          this.formData.append('files10', this.echartsChildData.echartsUrl10)
          this.formData.append('files11', this.echartsChildData.echartsUrl11)
          this.formData.append('files12', this.echartsChildData.echartsUrl12)
          this.formData.append('files13', this.echartsChildData.echartsUrl13)
          this.formData.append('files14', this.echartsChildData.echartsUrl14)
          this.formData.append('files14_12', this.echartsChildData.echartsUrl14_12)
          this.formData.append('files15', this.echartsChildData.echartsUrl15)
          this.formData.append('files16', this.echartsChildData.echartsUrl16)
          this.formData.append('files17', this.echartsChildData.echartsUrl17)
          this.formData.append('files18', this.echartsChildData.echartsUrl18)
          this.formData.append('files19', this.echartsChildData.echartsUrl19)
          this.formData.append('files20', this.echartsChildData.echartsUrl20)
          this.formData.append('files21', this.echartsChildData.echartsUrl21)
          this.formData.append('files22', this.echartsChildData.echartsUrl22)
          this.formData.append('files23', this.echartsChildData.echartsUrl23)
          this.formData.append('files24', this.echartsChildData.echartsUrl24)
          this.formData.append('files25', this.echartsChildData.echartsUrl25)
          this.formData.append('files26', this.echartsChildData.echartsUrl26)
          this.formData.append('files27', this.echartsChildData.echartsUrl27)
          this.formData.append('files28', this.echartsChildData.echartsUrl28)
          this.formData.append('files29', this.echartsChildData.echartsUrl29)
          this.formData.append('files30', this.echartsChildData.echartsUrl30)
          this.formData.append('files31', this.echartsChildData.echartsUrl31)
          this.formData.append('files32', this.echartsChildData.echartsUrl32)
          this.renderReport(this.formData)
        })
      },
      sendEchartsImg(val) {
        this.echartsChildData = val
      },
      onlineSave() {
        if (this.$route.query.comId || this._userInfo.data.comId) {
          this.actionSheetLeft = true
        } else {
          this.$toast('您已退出该医院')
        }
      },
      setWord() {
        if (this.$route.query.comId || this._userInfo.data.comId) {
          this.actionSheetRIght = true
        } else {
          this.$toast('您已退出该医院')
        }
      },
      // 上传文件
      handleUploadFile(data) {
        let formData = new FormData()
        let fileName = ''
        if(this.reportData.isDesensitization == '0'){
          fileName = this.reportData.contentObj.CONTENT2.substring(0,4) + '年**医务人员诊疗过程手卫生监测专项报告'
        }else{
          fileName = this.reportData.contentObj.reportTitle
        }
        formData.append('file', data, fileName + '.docx')
        this.$http.uploadFile(formData) .then((res) => { 
          if (res.code == 0) {
            this.reportData.fileId = res.data.fileId
            if (this.reportData.fileId) {
              this.handleWindowGk(fileName)
            }
          }
        })
      },
      // pc端下载文件
      downloadOrPc(blob) {
        let fileName = ''
        if(this.reportData.isDesensitization == '0'){
          fileName = this.reportData.contentObj.CONTENT2.substring(0,4) + '年**医务人员诊疗过程手卫生监测专项报告'
        }else{
          fileName = this.reportData.contentObj.reportTitle
        }
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName + '.docx'
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      },
      renderReport(data) {
        this.formData = new FormData() // 不加这个下载一次后再次下载会报错
        axios({
          method: 'post',
          url:'/node-report/handAreaStatistics2023/getHandAreaStatisticsReport_2023', // 线上
          // url:'/handAreaStatistics2023/getHandAreaStatisticsReport_2023', // 本地调试
          data: data,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          responseType: 'blob'
        }).then((res)=>{
          const content = res.data
          const blob = new Blob([content])
          if(this.reportData.isWeb == 1){
          //   console.log('pc端');
            this.downloadOrPc(blob)
          }else{
            console.log('移动端');
            this.handleUploadFile(blob)
          }
        })
      },
      handleMergeRow(tableData) {
        let tempArr = []
        let mergeData = []
        for (var i = 0; i < tableData.length; i++) {
          // 将数组每项中含有相同属性值的项合并
          if (tempArr.indexOf(tableData[i].CITY_NAME) === -1) {
            mergeData.push({
              CITY_NAME: tableData[i].CITY_NAME,
              dataInfo: [tableData[i]],
            })
            tempArr.push(tableData[i].CITY_NAME)
          } else {
            for (var j = 0; j < mergeData.length; j++) {
              if (mergeData[j].CITY_NAME == tableData[i].CITY_NAME) {
                mergeData[j].dataInfo.push(tableData[i])
                break
              }
            }
          }
        }
        return mergeData
      },
      handleMergeRow1(tableData) {
        let tempArr = []
        let mergeData = []
        for (var i = 0; i < tableData.length; i++) {
          // 将数组每项中含有相同属性值的项合并
          if (tempArr.indexOf(tableData[i].SWS_NAME) === -1) {
            mergeData.push({
              SWS_NAME: tableData[i].SWS_NAME,
              dataInfo: [tableData[i]],
            })
            tempArr.push(tableData[i].SWS_NAME)
          } else {
            for (var j = 0; j < mergeData.length; j++) {
              if (mergeData[j].SWS_NAME == tableData[i].SWS_NAME) {
                mergeData[j].dataInfo.push(tableData[i])
                break
              }
            }
          }
        }
        return mergeData
      },
      handleMergeRow2(tableData) {
        let tempArr = []
        let mergeData = []
        for (var i = 0; i < tableData.length; i++) {
          // 将数组每项中含有相同属性值的项合并
          if (tempArr.indexOf(tableData[i].DEPT_NAME) === -1) {
            mergeData.push({
              DEPT_NAME: tableData[i].DEPT_NAME,
              dataInfo: [tableData[i]],
            })
            tempArr.push(tableData[i].DEPT_NAME)
          } else {
            for (var j = 0; j < mergeData.length; j++) {
              if (mergeData[j].DEPT_NAME == tableData[i].DEPT_NAME) {
                mergeData[j].dataInfo.push(tableData[i])
                break
              }
            }
          }
        }
        return mergeData
      },
      handleMergeRow3(tableData) {
        let tempArr = []
        let mergeData = []
        for (var i = 0; i < tableData.length; i++) {
          // 将数组每项中含有相同属性值的项合并
          if (tempArr.indexOf(tableData[i].INDEX_NO) === -1) {
            mergeData.push({
              INDEX_NO:tableData[i].INDEX_NO,
              INDEX_NAME: tableData[i].INDEX_NAME,
              dataInfo: [tableData[i]],
            })
            tempArr.push(tableData[i].INDEX_NO)
          } else {
            for (var j = 0; j < mergeData.length; j++) {
              if (mergeData[j].INDEX_NO == tableData[i].INDEX_NO) {
                mergeData[j].dataInfo.push(tableData[i])
                break
              }
            }
          }
        }
        return mergeData
      },
      handleMergeRowTwo(tableData) {
        let tempArr = []
        let mergeData = []
        for (var i = 0; i < tableData.length; i++) {
          // 将数组每项中含有相同属性值的项合并
          if (tempArr.indexOf(tableData[i].TASK_ORDER) === -1) {
            mergeData.push({
              TASK_ORDER: tableData[i].TASK_ORDER,
              TASK_NAME: tableData[i].TASK_NAME,
              dataInfo: [tableData[i]],
            })
            tempArr.push(tableData[i].TASK_ORDER)
          } else {
            for (var j = 0; j < mergeData.length; j++) {
              if (mergeData[j].TASK_ORDER == tableData[i].TASK_ORDER) {
                mergeData[j].dataInfo.push(tableData[i])
                break
              }
            }
          }
        }
        return mergeData
      },
    }
  }
</script>
<style lang='scss' scoped>
  @import './public.scss';
  .container{
    display: flex;
    flex-direction: column;
    height: 100vh;
    .areaStatistics{
      flex: 1;
      overflow-y: scroll;
    }
  }
</style>
